import * as log from "loglevel";
import * as React from "react";

import { inject, observer } from "mobx-react";
import { Button, Dropdown, Form, Input } from "semantic-ui-react";

import { AdminStore } from "../../stores/admin-store";
import { LoadingSpinner } from "../common/loading-spinner";

interface IProps {
	adminStore?: AdminStore;
}

interface IState {
	surveyId: string;
	taskDropDownOptions: Array<any>;
	selectedTask: string;
}


@inject("adminStore") @observer
export class CodingTool extends React.Component<IProps, IState>{
	constructor(props, state) {
		super(props, state);
		this.state = {
			"surveyId": "",
			"taskDropDownOptions": [],
			"selectedTask": null
		};
		this.getCodingFile = this.getCodingFile.bind(this);
	}


	async getCodingFile() {
		let headers = ["Index", "Count", "Language ID", "Original Response", "Code Name", "Code Number", "Status"];
		let rawData = await this.props.adminStore.fetchCodingFile(this.state.selectedTask);
		let data = rawData.map((item) => {
			let newObj = {
				"Index": item[0],
				"Count": item[1],
				"Language ID": item[2],
				"Original Response": item[3],
				"Code Name": item[4],
				"Code Number": item[5],
				"Status": item[6].toString()
			};
			return newObj;
		});
		let filename = `coding_${this.state.surveyId}_${this.state.selectedTask}`;
		this.props.adminStore.ExportXlsx(data, filename, headers);

	}

	async getCodingTasks() {
		this.setState({
			"taskDropDownOptions": [],
			"selectedTask": null
		});
		let codingInfo = await this.props.adminStore.fetchCodingList(this.state.surveyId);
		let ddOption = [];
		Object.keys(codingInfo).map((key: any) => {
			let item = codingInfo[key];
			ddOption.push({
				"key": item.ID,
				"text": item.task_name,
				"value": item.ID.toString()
			});
		});
		this.setState({
			"taskDropDownOptions": ddOption
		});
	}

	handleChange(value) {
		this.setState({
			"selectedTask": value
		});
	}

	inputChange(value) {
		this.setState({
			"surveyId": value
		});
	}
	render() {
		return (
			<div>
				<Form>
					<Form.Field>
						<label>Survey ID</label>
						<Input placeholder="Survey ID" value={this.state.surveyId} onChange={(e, { value }) => this.inputChange(value)} />
						<Button type="submit" disabled={this.state.surveyId.length == 0} onClick={() => this.getCodingTasks()}>Fetch Coding Tasks</Button>
					</Form.Field>
					{
						this.state.taskDropDownOptions.length > 0 &&
						<Form.Field>
							<Dropdown
								placeholder="Select Task"
								fluid
								selection
								options={this.state.taskDropDownOptions} value={this.state.selectedTask} onChange={(e, { value }) => this.handleChange(value)}></Dropdown>
							<Button disabled={!(this.state.selectedTask && this.state.selectedTask.length > 0)} onClick={() => this.getCodingFile()}>Get Coding File</Button>
						</Form.Field>
					}
				</Form>


				{this.props.adminStore.loading &&
					<div>
						<LoadingSpinner text={"loading"} />
					</div>
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/admin/coding-tool.tsx